export default "__VITE_ASSET__DocH$hJp__"